import {
  CreditBreakdownCreditType,
  ItemAnalyticsModel,
  ItemListAnalyticsModel
} from '@/@types/client-api';
import { IContent, LinkItem } from '@/@types/cms';

export type CreditPlanMiniTrackerBaseProps = {
  creditsCounted: number;
  creditsEarned: number;
  creditsRequired: number;
  creditBreakdownCreditTypes?: CreditBreakdownCreditType[];
  jurisdictionMessage?: string;
  allOtherCreditsTooltip?: IContent[];
  showDonut?: boolean;
  primaryLink?: LinkItem;
  itemAnalyticsModel?: ItemAnalyticsModel;
  itemListAnalyticsModel?: ItemListAnalyticsModel;
};

export enum CreditPlanMiniTrackerBlockVariant {
  Personalized = 0,
  NonPersonalized = 1
}
